module.exports = __webpack_public_path__ + "img/blueprint.3179462f.png";